<div class="main-container background-img">
    <div class="container mt-3 mb-3">
        <div class="row">
            <div class="col-md-8 pl-0 offset-md-2">
                    <img src="../../assets/ipc-logo-rev.png" class="ipc-logo" alt="ipc logo">
            </div>
        </div>
    </div>
    <div class="container mt-5 p-3 mb-5">
        <form>
            <div class="row">
                <div class="col-md-8 offset-md-2 p-md-5 shadow bg-white mb-5 rounded">
                    <div class="text-center">
                        <h3 class="form-title">ADVISOR INFORMATION</h3>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label>First Name</label>
                            <input type="text" class="form-control" [(ngModel)]="fafName" name="fafName" placeholder="Enter First Name"
                            >
                        </div>
                        <div class="col">
                            <label>Last Name</label>
                            <input type="text" class="form-control" [(ngModel)]="falName" name="falName" placeholder="Enter Last Name"
                            >
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label>First Name (Optional)</label>
                            <input type="text" class="form-control" [(ngModel)]="safName" name="safName" placeholder="Enter First Name"
                                >
                        </div>
                        <div class="col">
                            <label>Last Name (Optional)</label>
                            <input type="text" class="form-control" [(ngModel)]="salName"  name="salName" placeholder="Enter Last Name"
                                >
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8 offset-md-2 p-md-5 shadow bg-white mb-5 rounded">
                    <div class="text-center">
                        <h3 class="form-title">CLIENT INFORMATION</h3>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label>First Name</label>
                            <input type="text" class="form-control" [(ngModel)]="fcfName" name="fcfName" placeholder="Enter First Name"
                                >
                        </div>
                        <div class="col">
                            <label>Last Name</label>
                            <input type="text" class="form-control" [(ngModel)]="fclName" name="fclName" placeholder="Enter Last Name"
                               >
                        </div>
                    </div>
                    <div class="row pt-4">
                        <div class="col">
                            <label>First Name (Optional)</label>
                            <input type="text" class="form-control" [(ngModel)]="scfName" name="scfName" placeholder="Enter First Name"
                                >
                        </div>
                        <div class="col">
                            <label>Last Name (Optional)</label>
                            <input type="text" class="form-control" [(ngModel)]="sclName" name="sclName" placeholder="Enter Last Name"
                                >
                        </div>
                    </div>
                    <div class="row pt-4">
                        <div class="col">
                            <label>Present Date:</label>
                            <input class="form-control" [(ngModel)]="date" type="date" name="date">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-8 offset-md-2 p-md-5 shadow bg-white rounded">
                    <div class="text-center">
                        <h3 class="form-title">Advisor Message</h3>
                    </div>
                    <div class="row pt-4">
                        <div class="col">
                            <textarea name="message" maxlength="800" [(ngModel)]="comments" placeholder="Add a personalized message to your client which will appear at the beginning of the report. (Character count: 600 characters no spaces)" rows="10" cols="80" style="border: none; width: 100%;"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pt-4">
                <div class="col-md-4 offset-md-2 text-left">
                    <!-- <button class="btn btn-outline-primary" [routerLink]="['/summary']">Back</button> -->
                </div>
                <div class="col-md-4 text-right">
                    <button class="btn btn-outline-primary btn-next shadow" type="button" (click)="onClickSubmit()">Submit</button>
                </div>
            </div>
        </form>
    </div>
</div>